export { RestaurantAnalyticsDashboard } from "./pages";
